import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Button, Switch } from 'antd';
import dayjs from 'dayjs';

const AddInternalOrderMaster = ({ open, onCancel, onSubmit, initialData = null, setEditInternalOrder }) => {
        const [form] = Form.useForm();
        const isEditMode = initialData && Object.keys(initialData).length > 0;

        const handleOk = async () => {
                try {
                        const values = await form.validateFields();
                        const formattedValues = {
                                ...values,
                                ZERO_DATE: values.ZERO_DATE?.format('DD-MMM-YYYY') || null,
                                IS_ACTIVE: values.IS_ACTIVE ? 1 : 0,
                                IS_MONITORING: values.IS_MONITORING ? 1 : 0,
                        };
                        // console.log('Payload:', formattedValues);
                        const result = await onSubmit(formattedValues);

                        if (result?.status === 'success') {
                                form.resetFields();
                                setEditInternalOrder({});
                        }
                } catch (err) {
                        console.log('Validation or submission error:', err);
                }
        };

        // useEffect(() => {
        //         if (initialData && isEditMode) {
        //                 const formattedData = {
        //                         ...initialData,
        //                         ZERO_DATE: initialData.ZERO_DATE ? dayjs(initialData.ZERO_DATE, 'DD-MMM-YYYY') : null,
        //                 };
        //                 form.setFieldsValue(formattedData);
        //         } else {
        //                 form.resetFields();
        //         }
        // }, [initialData, open]);

        useEffect(() => {
                if (initialData && isEditMode) {
                        const formattedData = {
                                ...initialData,
                                ZERO_DATE: initialData.ZERO_DATE
                                        ? dayjs(initialData.ZERO_DATE, 'DD-MMM-YYYY')
                                        : null,
                        };

                        form.setFieldsValue(formattedData);
                } else {
                        form.resetFields();

                        form.setFieldsValue({
                                IS_ACTIVE: false,
                                IS_MONITORING: false,
                        });
                }
        }, [initialData, open]);
        return (
                <Modal
                        title={isEditMode ? 'Edit Internal Order' : 'Add Internal Order'}
                        open={open}
                        onCancel={() => {
                                form.resetFields();
                                onCancel();
                        }}
                        onOk={handleOk}
                        footer={[
                                <Button
                                        key="cancel"
                                        onClick={onCancel}>
                                        Cancel
                                </Button>,
                                <Button
                                        key="submit"
                                        type="primary"
                                        onClick={handleOk}>
                                        {isEditMode ? 'Update Internal Order' : 'Add Internal Order'}
                                </Button>,
                        ]}
                        width={600}>
                        <Form
                                form={form}
                                layout="vertical"
                                className="custom-form-scroll"
                                style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                {[
                                        { label: 'IO Number', name: 'IO_NO', disabled: isEditMode },
                                        { label: 'Revision Number', name: 'REV_NO', disabled: isEditMode },
                                        { label: 'BS Unit', name: 'BS_UNIT' },
                                        { label: 'Zero Date', name: 'ZERO_DATE', isDate: true },
                                        { label: 'Admin Section Code', name: 'ADMIN_SECTION_CODE' },
                                        { label: 'Admin Section Name', name: 'ADMIN_SECTION_NAME' },
                                        { label: 'Customer Code', name: 'CUST_CODE' },
                                        { label: 'Customer Name', name: 'CUST_NAME' },
                                        { label: 'Project Code', name: 'PROJ_CODE' },
                                        { label: 'Project Name', name: 'PROJ_NAME' },
                                        { label: 'Is Active', name: 'IS_ACTIVE', isSwitch: true },
                                        { label: 'Is Monitoring', name: 'IS_MONITORING', isSwitch: true },
                                ].map(({ label, name, isDate, isSwitch, disabled }) => (
                                        <Form.Item
                                                key={name}
                                                name={name}
                                                label={
                                                        <div className="flex justify-between items-center gap-2">
                                                                <label className="text-left pr-4">
                                                                        {label}
                                                                        <span className="text-red-500">*</span>
                                                                </label>
                                                        </div>
                                                }
                                                labelCol={{ span: 7 }} // Roughly 40% in 24-grid system
                                                wrapperCol={{ span: 14 }} // Remaining 60%
                                                layout="horizontal"
                                                required={false} // ✅ Suppresses automatic red asterisk
                                                rules={[
                                                        {
                                                                required: true,
                                                                message: `${label} is required`,
                                                        },
                                                ]}>
                                                {isDate ? (
                                                        <DatePicker
                                                                format="DD-MMM-YYYY"
                                                                className="w-full"
                                                        />
                                                ) : isSwitch ? (
                                                        <Switch
                                                                checkedChildren="Yes"
                                                                unCheckedChildren="No"
                                                        />
                                                ) : (
                                                        <Input
                                                                className="w-full"
                                                                disabled={disabled}
                                                        />
                                                )}
                                        </Form.Item>
                                ))}
                        </Form>
                </Modal>
        );
};

export default AddInternalOrderMaster;
